// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductModuleHeading_wrapper__6FWD1","heading":"ProductModuleHeading_heading__TbsA9","text":"ProductModuleHeading_text__oc-Yg"};